var map = {
	"./1.png": "54fc",
	"./10.png": "3b5a",
	"./11.png": "1ee9",
	"./12.png": "82e9",
	"./2.png": "8923",
	"./3.png": "de69",
	"./4.png": "a872",
	"./5.png": "36d6",
	"./6.png": "7787",
	"./7.png": "fb27",
	"./8.png": "8d7e",
	"./9.png": "b437"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "58e4";